import {range} from '@/helpers';

export class Paginator {
  page: number;
  perPage: number;
  total: number;

  get pages() {
    if (this.total === 0 || this.total === null) {
      return 0;
    }
    return Math.ceil(this.total / this.perPage);
  }

  get hasPrev() {
    return this.page > 1;
  }

  get prevNum() {
    if (!this.hasPrev) {
      return null;
    }
    return this.page - 1;
  }

  get hasNext() {
    return this.page < this.pages;
  }

  get nextNum() {
    if (!this.hasNext) {
      return null;
    }
    return this.page + 1;
  }

  constructor(page: number, perPage: number, total: number) {
    this.page = page;
    this.perPage = perPage;
    this.total = total;
  }

  // https://github.com/pallets-eco/flask-sqlalchemy/blob/3.1.x/src/flask_sqlalchemy/pagination.py#L263
  // https://flask-sqlalchemy.palletsprojects.com/en/3.1.x/pagination/
  * iterPages() {
    const leftEdge = 2;
    const leftCurrent = 2;
    const rightCurrent = 2;
    const rightEdge = 2;

    const pagesEnd = this.pages + 1;

    if (pagesEnd === 1) {
      return;
    }

    const leftEnd = Math.min(1 + leftEdge, pagesEnd);
    yield* range(1, leftEnd);

    if (leftEnd === pagesEnd) {
      return;
    }

    const midStart = Math.max(leftEnd, this.page - leftCurrent);
    const midEnd = Math.min(this.page + rightCurrent + 1, pagesEnd);

    if (midStart - leftEnd > 0) {
      yield null;
    }

    yield* range(midStart, midEnd);

    if (midEnd === pagesEnd) {
      return;
    }

    const rightStart = Math.max(midEnd, pagesEnd - rightEdge);

    if (rightStart - midEnd > 0) {
      yield null;
    }

    yield* range(rightStart, pagesEnd);
  }
}
